import { Stack } from "@mui/material";
import { Chip, Typography } from "@platform/design-system";

/**
 * Marks a census file the RFP is not quoted on. Only the newest census file is
 * read, so checking an older one would only suggest changes nobody uses.
 */
export const CensusNotUsedNote = (): React.JSX.Element => (
  <Stack
    direction="row"
    alignItems="center"
    gap={1.5}
    sx={{ paddingY: 1 }}
    data-testid="census-not-used-note"
  >
    <Chip
      label="Not used"
      variant="subtle"
      size="small"
      leadingVisual={false}
    />
    <Typography variant="body-medium" color="textSecondary">
      Only the newest census file is used.
    </Typography>
  </Stack>
);
